import styled, { createGlobalStyle } from 'styled-components';
import { theme } from '../../styled/layout/theme';
import { Button } from '../../styled/Button/wrappers';
import { size } from '../../styled/layout/helpers';

export const GlobalChatStyle = createGlobalStyle`
  [data-puzzel-chat] {
      z-index: ${theme.layers.chat};
  }
  
  [data-puzzel-chat] input {
      background-color: ${theme.colors.bg.outer};
      border: none;
      border-radius: 5px;
      font-weight: 600;
      margin: -4px 0px -4px 0px;
  }
  
  [data-puzzel-chat] input::placeholder {
      text-align: center;
  }

  [data-puzzel-chat] p {
      margin: px;
  }
  
  [data-puzzel-chat] a {
      border: 1px solid ${theme.colors.border.main};
      padding: 8px;
      display: block;
      margin: 8px;
      color: black;
      border-radius: 150px;
      font-weight: 600;
  }

  [data-puzzel-chat] h6 {
      color: ${theme.colors.text.alt};
      font-weight: 600;
      padding: 0;
      margin-top: 8px;
      margin: 16px 0px -8px 0px;
      font-size: 12px
  }
  
  [data-puzzel-chat] a:hover {
      background-color: #F2F2F2;
      background-color: ${theme.colors.button.ghost};
  }
  
  div[data-puzzel-chat] button {
      display: flex;
      justify-content: space-evenly;
      border: 1px solid white;
  }
`;

export const ChatButton = styled(Button)`
  top: calc(100% - 10px) !important;
  left: calc(100% - 10px) !important;
  width: 160px !important;
  height: 60px !important;
  position: fixed;
  transform: translate(calc(-100% + 0px), calc(-100% - 0px)) !important;
  border: 1px solid white;
  border-radius: 30px;
  z-index: ${theme.layers.belowBackdrop};
`;

export const NoConsentChatInformation = styled.div`
  z-index: ${theme.layers.chat};
  top: calc(100% - 10px) !important;
  left: calc(100% - 10px) !important;
  background-color: white;
  position: fixed;
  transform: translate(calc(-100% + 0px), calc(-100% - 0px)) !important;
  height: 600px;
  width: 300px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  font-weight: 200;
  align-items: center;
  ${theme.screens.LtSm} {
    width: 100%;
    height: 100%;
    top: 100% !important;
    left: 100% !important;
  }
`;

export const ConsentChatBanner = styled.div`
  background-color: ${theme.colors.bg.chat};
  color: white;
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: space-between;
  padding: ${size(1)};
  font-size: ${size(3)};
  position: absolute;
  top: 0;
`;

export const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: ${size(2)};
  align-items: center;
`;

export const Description = styled.div`
  margin: ${size(2)};
`;
